import clsx from "clsx";
import { useForm } from "react-hook-form";
import { Form, InputGroup } from "react-bootstrap";
import _ from "lodash";
import PAGE from "../../../../utils/Destination";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import React, { useState } from "react";
import * as axiosInstance from "../../../../services/axiosInstance";
import * as authSelectors from "../../../../selectors/auth";
import * as StorageManager from "../../../../utils/StorageManager";
import constants from "../../../../constants";
import * as userActions from "../../../../action/user";
import { useDispatch } from "react-redux";
import LoadingOverlay from "../../../../components/LoadingOverlay";
import * as CryptoHelper from "../../../../utils/CryptoHelper";

function ChangePasswordComponent() {
  const [loading, setLoading] = useState(false);
  const [currentPasswordView, setCurrentPasswordView] = useState(false);
  const [newPasswordView, setNewPasswordView] = useState(false);
  const [confirmPasswordView, setConfirmPasswordView] = useState(false);
  const dispatch = useDispatch();
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    mode: "onTouched",
    reValidateMode: "onSubmit",
    // reValidateMode: "onChange",
    defaultValues: null,
    values: null,
  });

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      const encrytionResult = await axiosInstance.post(
        "/clientarea/encryption/create",
        {},
        false,
        false,
        "",
        {},
        true,
      );
      const result = _.get(encrytionResult,['data'],null)
      const encryptedKey = CryptoHelper.decryptData(result.key, result.salt, result.iv, process.env.REACT_APP_PASSPHRASE);
      const encryptedPassword = CryptoHelper.encryptData(values.current_password, result.salt, result.iv, encryptedKey);
      const encryptedNewPassword = CryptoHelper.encryptData(values.new_password, result.salt, result.iv, encryptedKey);
      const encryptedNewPasswordConfirmation = CryptoHelper.encryptData(values.new_password_confirmation, result.salt, result.iv, encryptedKey);
      const newSubmitValues = {...values,current_password: encryptedPassword,new_password: encryptedNewPassword,new_password_confirmation: encryptedNewPasswordConfirmation,encryption_id:result.id};
      const response = await axiosInstance.post(
        "clientarea/profile/change-password",
        newSubmitValues,
        true,
        false,
        "Change Password Successfully",
      );
      const token = authSelectors.getAuthToken(response);
      const user = authSelectors.getAuthUser(response);
      await StorageManager.setToken(constants.AUTH_TOKEN, token);
      dispatch(userActions.updateUserDetail(user));
    } catch (e) {
      console.log("ee" + e);
    } finally {
      setLoading(false);
    }
  };

  const onError = (error) => {};
  return (
    <div className="shadow mt-3">
      <div className={clsx("custom-card-label-container")}>
        <h2>Password Settings</h2>
      </div>
      <div className="profile-other-info">
        <Form onSubmit={handleSubmit(onSubmit, onError)} className="mt-3">
          <Form.Label className="formLabel required">
            Current Password
          </Form.Label>
          <InputGroup className="mb-3">
            <Form.Control
              className="formControl"
              isInvalid={!_.isEmpty(errors && errors.current_password)}
              type={currentPasswordView ? "input" : "password"}
              placeholder="Enter your password"
              name="password"
              {...register("current_password", {
                required: "Please enter your password",
              })}
            ></Form.Control>
            <InputGroup.Text id="basic-addon1">
              <FontAwesomeIcon
                onClick={() =>
                  setCurrentPasswordView((prevState) => !prevState)
                }
                className="password-icon"
                icon={currentPasswordView ? faEyeSlash : faEye}
                color="#666666"
              />
            </InputGroup.Text>
            {errors.current_password && (
              <Form.Control.Feedback type="invalid">
                {errors.current_password.message}
              </Form.Control.Feedback>
            )}
          </InputGroup>
          <Form.Label className="formLabel required">New Password</Form.Label>
          <InputGroup className="mb-3">
            <Form.Control
              className="formControl"
              isInvalid={!_.isEmpty(errors && errors.new_password)}
              type={newPasswordView ? "input" : "password"}
              placeholder="Enter your new password"
              name="new_password"
              {...register("new_password", {
                required: "Please enter your new password",
              })}
            ></Form.Control>
            <InputGroup.Text id="basic-addon1">
              <FontAwesomeIcon
                onClick={() => setNewPasswordView((prevState) => !prevState)}
                className="password-icon"
                icon={newPasswordView ? faEyeSlash : faEye}
                color="#666666"
              />
            </InputGroup.Text>
            {errors.new_password && (
              <Form.Control.Feedback type="invalid">
                {errors.new_password.message}
              </Form.Control.Feedback>
            )}
          </InputGroup>
          <Form.Label className="formLabel required">Confirm Password</Form.Label>
          <InputGroup className="mb-3">
            <Form.Control
              className="formControl"
              isInvalid={!_.isEmpty(errors && errors.new_password_confirmation)}
              type={confirmPasswordView ? "input" : "password"}
              placeholder="Enter your confirm password"
              name="new_password"
              {...register("new_password_confirmation", {
                required: "Please enter your confirm password",
              })}
            ></Form.Control>
            <InputGroup.Text id="basic-addon1">
              <FontAwesomeIcon
                onClick={() => setConfirmPasswordView((prevState) => !prevState)}
                className="password-icon"
                icon={confirmPasswordView ? faEyeSlash : faEye}
                color="#666666"
              />
            </InputGroup.Text>
            {errors.new_password_confirmation && (
              <Form.Control.Feedback type="invalid">
                {errors.new_password_confirmation.message}
              </Form.Control.Feedback>
            )}
          </InputGroup>
          <div className="text-left">
            <button
              disabled={loading}
              className={clsx("btn btn-primary btn-fill mt-2 mb-2")}
              type="submit"
            >
              Change Password
            </button>
          </div>
        </Form>
        <LoadingOverlay loading={loading}></LoadingOverlay>
      </div>
    </div>
  );
}

export default ChangePasswordComponent;
